import { Button, Col, Form, Input, Row } from "antd";
import ModalComponent from "../ModalComponent";
import { showNotitfication } from "../../utils/Utils";
import {
  toCheckMyListBalance,
  toGetMylistKeys,
  toSendMyList,
  toSendMylistData,
} from "../../apis/actions/paymentMethods.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import {
  toGetMyLoyaltyHistory,
  toGetMyWalletHistory,
  toGetProfil,
} from "../../apis/actions/auth.actions";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
const MyListPayment = ({ isOpen, setIsOpen }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { data } = useSelector((state: RootState) => state.tabby.myListKeys);
  const { balanceData } = useSelector(
    (state: RootState) => state.tabby.myListCheckBalance
  );

  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    dispatch(toGetMylistKeys());
  }, [dispatch]);
  const handleGift = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const successbalance = (await dispatch(
        toCheckMyListBalance({
          cardNumber: values.card_number,
          baseURL: data.baseURL,
          Token: data.Token,
          AutoChapeauIp: data.IP,
        })
      )) as any;
      const balanceReturned = successbalance.payload.data;
      if (
        successbalance?.payload?.code &&
        successbalance?.payload?.code !== 200
      ) {
        showNotitfication(
          i18n.language == "ar"
            ? "رقم البطاقة غير صحيح ، يرجى التحقق من الرمز و إعادة المحاولة مجددا ."
            : successbalance?.payload?.message,
          "error"
        );
        return;
      } else if (successbalance?.payload?.code == 200) {
        if (balanceReturned.remaining_value <= 0) {
          showNotitfication(
            i18n.language == "ar"
              ? "تم إستخدام بطاقة الهدية سابقا."
              : "Gift card has already been used.",
            "error"
          );
          return;
        }
      }

      const json = {
        ...values,
        email: "admin@autochapeau.com",
        store_id: "AC1_SAR",
        redemption_amount: balanceReturned?.remaining_value,
      };
      const success = (await dispatch(
        toSendMyList({
          data: { giftcard: json },
          baseURL: data.baseURL,
          Token: data.Token,
          AutoChapeauIp: data.IP,
        })
      )) as any;
      const myList = success?.payload?.data;
      if (myList?.code === 200) {
        showNotitfication(myList?.message, "success");
        const amount = {
          amount: myList.data.transaction.transaction_amount,
        };
        form.resetFields();
        dispatch(toSendMylistData(amount));
        setIsOpen(false);
        dispatch(toGetMyWalletHistory());
        await dispatch(toGetProfil(i18n.language));
      } else if (myList?.code == 400) {
        if (myList?.message?.toLowerCase().includes("expired")) {
          showNotitfication(
            i18n.language == "ar"
              ? "انتهت صلاحية بطاقة الهدية."
              : "This gift card is expired.",
            "error"
          );
        } else {
          showNotitfication(
            i18n.language == "ar"
              ? "رقم البطاقة غير صحيح ، يرجى التحقق من الرمز و إعادة المحاولة مجددا ."
              : "Gift card number is incorrect. Please check and enter the number again.",
            "error"
          );
        }
      } else if (myList?.code == 422) {
        showNotitfication(
          i18n.language == "ar"
            ? "تم إستخدام بطاقة الهدية سابقا."
            : "Gift card has already been used.",
          "error"
        );
      }
    } catch (error) {}
  };
  return (
    <ModalComponent
      title={t("myList.title")}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      closeOnOutsideClick={true}
      width={500}
      centered={true}
      canvasBackdrop
    >
      <Form form={form} layout="vertical" className="mt-20">
        <Row gutter={16}>
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <Form.Item
              label={t("myList.card_number")}
              name="card_number"
              rules={[{ required: true, message: t("myList.card_required") }]}
              labelCol={{ className: "text-md-bold" }}
            >
              <Input
                type="text"
                className="ac--input"
                placeholder={t("myList.enter_card_number")}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="mt-20" justify="end">
          <Button className="text-md ac--btn-edit-save" onClick={handleGift}>
            {t("myList.btn")}{" "}
          </Button>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default MyListPayment;
